import ApiService from "../core/services/api.service";
import store from "../core/services/store";
import {
  SET_RESERVATIONS_COUNT,
} from "../core/services/store/notification.module";

export default {
  getRequest(guid) {
    return ApiService.get(`admin/v1/subscriptions/${guid}`);
  },
  getRequests() {
    return ApiService.get(`coordinator/v1/Requests`);
  },
  getReservations() {
    return ApiService.get(`admin/v1/Subscriptions/SubscriptionsToProcess`);
  },
  getScheduledReservations() {
    return ApiService.get(`coordinator/v1/Requests/scheduledreservations`);
  },
  getPromotions() {
    return ApiService.get(`coordinator/v1/Requests/promotions`);
  },
  getQuotes() {
    return ApiService.get(`admin/v1/Subscriptions/referrals`);
  },
  activateSubscription(obj) {
    return ApiService.post(`admin/v1/subscriptions/activate`, obj);
  },
  changeSubscriptionEndDate(obj) {
    return ApiService.post(`admin/v1/subscriptions/changeEndDate`, obj);
  },
  changeRequestPartner(obj) {
    return ApiService.post(`coordinator/v1/Requests/ChangePartner`, obj);
  },
  quoteRequest(obj) {
    return ApiService.post(`coordinator/v1/Requests/quote`, obj);
  },
  quoteSubServicesRequest(obj) {
    return ApiService.post(`coordinator/v1/Requests/quotesubservices`, obj);
  },
  cancelRequest(obj) {
    return ApiService.post(`coordinator/v1/Requests/cancel`, obj);
  },
  resultRequest(obj) {
    return ApiService.post(`coordinator/v1/Requests/result`, obj);
  },
  getPrescription(guid) {
    return ApiService.getBuffer(`coordinator/v1/Requests/prescription/${guid}`);
  },
  modifyRequestSubServices(obj) {
    return ApiService.post(`coordinator/v1/Requests/ModifySubServices`, obj);
  },

  getRequestCount() {
    this.getReservations().then((result) => {
      store.dispatch(SET_RESERVATIONS_COUNT, result.data.length);
    });


  },

  getRequestStateLable(state) {
    var result = {};
    switch (state) {
      case 1:
        result.color = "warning";
        break;
      case 2:
        result.color = "success";
        break;
      case 3:
        result.color = "danger";
        break;  
      default:
        result.lable = "";
        result.color = "";
        break;
    }
    return result;
  },
};
